var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CommonForm',{attrs:{"form-json":_vm.formjson},on:{"search":_vm.formSearch}}),_c('CommonTable',{ref:"table",attrs:{"data":_vm.tableData,"total":_vm.total,"table-json":_vm.tablejson},on:{"change":_vm.handleTableChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }